var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tabs', {
    attrs: {
      "grow": "",
      "height": _vm.$vuetify.breakpoint.lgAndUp ? 80 : '',
      "slider-size": _vm.$vuetify.breakpoint.lgAndUp ? 4 : '2'
    }
  }, [_c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/education"
    }
  }, [_vm._v("교육소개")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/education/law"
    }
  }, [_vm._v("법률지원")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }